import { createFileRoute, redirect } from '@tanstack/react-router';
import { FEATURE_FLAGS } from '@vizit/constants';
import { getFeatureFlag } from '@vizit/feature-flags';
import { ExplorePage } from '../../../pages';
import { PagesProvider } from '../../../pages/providers/pages-provider';
import { beforeLoadAuthenticatedValidation } from '../../../router/route-utils';
import { NavbarPageTemplate } from '../../../templates';

export const Route = createFileRoute('/_authenticated/explore/')({
  staticData: {
    pageName: 'Explore',
  },
  beforeLoad: async ({ context, location }) => {
    await beforeLoadAuthenticatedValidation(context, location);

    const isClipExperimentEnabled = await getFeatureFlag(FEATURE_FLAGS.TMP_CLIP_EXPERIMENT, false);
    if (isClipExperimentEnabled) {
      throw redirect({ to: '/' });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PagesProvider
      template={NavbarPageTemplate}
      templateProps={{ currentRoute: '/explore', contentClassName: 'flex flex-col items-center h-full' }}
    >
      <ExplorePage />
    </PagesProvider>
  );
}
